(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olfactory-notes-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('note-carousel')) {
  customElements.define('note-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      const track = this.querySelector('.notes-carousel__track');
      if (!track) return;

      const pages = Array.from(track.querySelectorAll('.notes-carousel__page'));
      if (pages.length <= 1) return;

      let currentPage = 0;
      const motionReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.carouselTimer = window.setInterval(() => {
        currentPage = (currentPage + 1) % pages.length;
        const target = pages[currentPage].offsetLeft - pages[0].offsetLeft;
        track.scrollTo({ left: target, behavior: motionReduced ? 'auto' : 'smooth' });
      }, 4000);
    }

    disconnectedCallback() {
      if (this.carouselTimer) window.clearInterval(this.carouselTimer);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ro-profile-results"] && !Shopify.designMode) return;
  try {
    
(async()=>{
const root=document.querySelector('[data-ro-explore]');if(!root)return;
const params=new URLSearchParams(location.search),field=params.get('ro_field'),value=params.get('ro_value');
const grid=root.querySelector('[data-ro-grid]'),status=root.querySelector('[data-ro-status]');
const norm=v=>String(v??'').replace('gid://shopify/Metaobject/','');let count=0;
const filter=scope=>scope.querySelectorAll('[data-ro-card]').forEach(card=>{
const data=JSON.parse(card.querySelector('[data-ro-data]').textContent);
let values=Array.isArray(data[field])?data[field]:[data[field]];
if(field==='custom.perfumista')values=values.flatMap(v=>String(v??data.vendor??'').split(/ y | & |,|;/).map(name=>name.trim()).filter(Boolean));
const match=!field||!value||values.some(v=>norm(v)===norm(value));card.hidden=!match;if(match)count++;
});
const label=params.get('ro_label');
if(label||value&&!value.includes('gid://'))root.querySelector('[data-ro-selection]').textContent='· '+(label||value.replaceAll('-',' '));
try{
filter(root);let next=root.querySelector('[data-ro-next]');
while(next){
const url=new URL(next.getAttribute('href'),location.origin);url.searchParams.set('view','ro-profile');
if(params.get('preview_theme_id'))url.searchParams.set('preview_theme_id',params.get('preview_theme_id'));
next.remove();const response=await fetch(url);if(!response.ok)throw new Error('catalog');
const doc=new DOMParser().parseFromString(await response.text(),'text/html'),incoming=doc.querySelector('[data-ro-explore]');
if(!incoming)throw new Error('catalog');filter(incoming);incoming.querySelectorAll('[data-ro-card]').forEach(card=>grid.append(card));next=incoming.querySelector('[data-ro-next]');
}status.textContent=count+' '+root.dataset.result;
}catch(error){status.textContent=root.dataset.error;}
})();

  } catch(e) { console.error(e); }
})();
})();
